import { Controller } from "@hotwired/stimulus"

// 個人/法人のアカウントタイプ切り替え時の確認ダイアログを表示するController
// フォームに入力がある場合、切り替え前に確認を求める
// また、バリデーションエラー時にエラーメッセージへ自動スクロールする
export class AccountTypeSwitcherController extends Controller {
  connect() {
    if (this._hasErrors()) {
      this._scrollToTop()
    }
  }

  // アカウントタイプ切り替えリンククリック時の確認処理
  confirmSwitch(event) {
    // 入力値がある場合のみ確認ダイアログを表示
    if (this._hasInputValues()) {
      if (!confirm('入力していた値がクリアされます。本当によろしいですか？')) {
        event.preventDefault()
        event.stopPropagation()
      }
    }
  }

  // フォームに入力値があるかチェック
  _hasInputValues() {
    const form = this.element.querySelector('form')
    if (!form) return false

    return this._hasTextInputValues(form) || this._hasSelectValues(form)
  }

  // テキスト系フィールドに入力があるか
  _hasTextInputValues(form) {
    const textInputs = form.querySelectorAll('input[type="text"], input[type="tel"], textarea')
    return Array.from(textInputs).some(input => input.value.trim() !== '')
  }

  // セレクトボックスで初期値以外が選択されているか
  _hasSelectValues(form) {
    const selects = form.querySelectorAll('select')
    return Array.from(selects).some(select => select.selectedIndex > 0)
  }

  // エラーメッセージが存在するかチェック
  _hasErrors() {
    return this.element.querySelector('#error_explanation') !== null
  }

  // ページ先頭へスクロール
  _scrollToTop() {
    requestAnimationFrame(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    })
  }
}
